import type { PersistentChatMessageData } from "~shared/types/persistent-chat-types";

/** Show the survey after every N completed assistant replies in a chat. */
export const CHAT_EXPERIENCE_SURVEY_INTERVAL = 5;

export function countVisibleAssistantReplies(messages: PersistentChatMessageData[]): number {
  let count = 0;
  for (const message of messages) {
    if (message.role === "assistant" && !message.metadata?.hiddenFromUI) count += 1;
  }
  return count;
}

/** Whether enough new assistant replies have accrued since the last survey to show it again. */
export function isSurveyEligibleByCount(
  assistantReplyCount: number,
  baseline: number,
  interval = CHAT_EXPERIENCE_SURVEY_INTERVAL,
): boolean {
  return assistantReplyCount > 0
    && assistantReplyCount - baseline >= interval;
}
